export default __webpack_public_path__ + "static/media/Blast.ce31dc79.png";